import { Component, ViewChild, ElementRef, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { SnackbarService } from "./../../services/snackbar.service";


@Component({
  selector: 'control-capture-media',
  templateUrl: './capture-media.component.html',
  styleUrls: ['./capture-media.component.scss']
})
export class CaptureMediaComponent implements OnInit, OnDestroy {
  captureImageEmitter: EventEmitter<any> = new EventEmitter<any>;
  constructor(
    public dialogRef: MatDialogRef<CaptureMediaComponent>,
    public snackbarService:SnackbarService
  ) { }
  ngOnInit(): void {
    this.startCamera();
  }
  @ViewChild('videoElement') videoElement: ElementRef;
  @ViewChild('canvasElement') canvasElement: ElementRef;
  capturedImage: string;
  capturedVideo: string;
  mediaRecorder: MediaRecorder;
  recordedChunks: any[] = [];
  capturing: boolean = true;
  imageCaptured: boolean = false;
  videoCaptured: boolean = false;
  stream: MediaStream;
  startCamera() {
    this.imageCaptured = false;
    this.videoCaptured = false;
    this.capturing = true;
    navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
      this.videoElement.nativeElement.srcObject = stream;
      this.stream = stream;
    }).catch((err) => {
      console.error('Error accessing camera: ', err);
      // this.openSnackbar('Error accessing camera! Please try again')
    });
  }
  stopCamera() {
    console.log(this.stream);
    console.log(this.stream.getTracks());
    if (this.stream) {
      this.stream?.getTracks().forEach(track => track.stop());
      // this.closeDialog()
    }
  }

  captureImage() {
try{
  this.imageCaptured = true;
  this.capturing = false;
  const video = this.videoElement.nativeElement;
  const canvas = this.canvasElement.nativeElement;
  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  const context = canvas.getContext('2d');
  context.drawImage(video, 0, 0, canvas.width, canvas.height);
  this.capturedImage = canvas.toDataURL('image/png');
  console.log(this.capturedImage);
  console.log(typeof this.capturedImage);
  this.stopCamera();
} catch(error){
    console.log('Error capturing image :', error)
      this.openSnackbar('Error accessing camera! Please try again')
    this.closeDialog();
}

  }
  uploadImage() {
    this.captureImageEmitter.next(this.capturedImage);
    // this.openSnackbar('Image uploaded successfully!')
    this.closeDialog()
  }
  openSnackbar(message: string) {
    this.snackbarService.open(message);
  }

  captureVideo() {
    this.videoCaptured = true;
    this.capturing = false;
    const stream = this.videoElement.nativeElement.srcObject;
    this.mediaRecorder = new MediaRecorder(stream);
    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        this.recordedChunks.push(event.data);
      }
    };
    this.mediaRecorder.onstop = () => {
      const blob = new Blob(this.recordedChunks, { type: 'video/webm' });
      this.capturedVideo = URL.createObjectURL(blob);
      this.recordedChunks = [];
    };
    this.mediaRecorder.start();
    setTimeout(() => {
      this.mediaRecorder.stop();
    }, 5000); // Record for 5 seconds
  }
  closeDialog(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.stopCamera();
  }
}
